import { render } from "./GeneralDataForm.vue?vue&type=template&id=52c8c467&scoped=true&ts=true"
import script from "./GeneralDataForm.vue?vue&type=script&lang=ts"
export * from "./GeneralDataForm.vue?vue&type=script&lang=ts"

import "./GeneralDataForm.vue?vue&type=style&index=0&id=52c8c467&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c8c467"]])

export default __exports__